module.exports = __webpack_public_path__ + "img/CD.eef94a34.png";